<script lang="ts">
	import FormWithLabel from "../../molecules/FormWithLabel.svelte";
	import type { RecruitmentService } from "../../services/recruitment.service";

	export let service: RecruitmentService
	export let klass = ''
	const model = service.store.model
	const models = service.store.yearlyIncomes
</script>

<div class="{klass}">
	<FormWithLabel
		label="給与"
		input={service.handleYearlyIncomes}
		values={$model.yearlyIncomes}
		inputType="checkboxes"
		options={$models}
	/>
</div>

